<div class="container pause-container">
  <button class="its-button" (click)="resume()">{{"WORKOUT.WORKOUT-EXE.RESUME-BTN"| translate}}</button>
  <p (click)="leave()">{{"WORKOUT.WORKOUT-EXE.LEAVE-BTN"| translate}}</p>
</div>
